import React from "react";
import MainMenu from "../components/navigations/MainMenu";
import { Link } from "react-router-dom";

export const DocCard = ({ title, link }) => {
  return (
    <div className="flex justify-between  border p-4 rounded my-3">
      <p>{title}</p>
      <p className="text-sm text-blue-700">
        <Link to={link}>Click here</Link>
      </p>
    </div>
  );
};

const ImportantDocs = () => {
  return (
    <div className="relative">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div className="pt-36 py-20">
        <div className="mx-4 md:mx-32 bg-gray-50 border rounded p-4">
          <div className="">
            <DocCard title="Mandatory Public Disclosure" link="/disclosure" />
            <DocCard title="Affidavit & SMC Member" link="/affidavit" />
            <DocCard title="Building Safety" link="/building_safety" />
            <DocCard title="Fire Safety" link="/fire_safety" />
            <DocCard title="NOC" link="/noc" />
            <DocCard title="Recognition" link="/recognition" />
            <DocCard title="Sanitation Certificate" link="/sanitation" />
            <DocCard
              title="Parent Teacher Association - 2021-2022"
              link="/pta"
            />
            <DocCard
              title="Certificate of Registration"
              link="/register_certificate"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportantDocs;
